import styled from 'styled-components';
import { Media } from 'enums';

export const Container = styled.div`
  width: 100%;
  @media ${Media.tablet} {
    max-width: 384px;
  }
`;
